<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    

    <b-row v-if="!loading">
      <b-col>
       
        
              <small class="text-muted"> {{ shippingManifest.reference }}</small
              > | 
              <strong v-if="shippingManifest.courier"> {{ shippingManifest.courier.name }}</strong>
              <p>Select Jobs for Manifest.</p>
           

        <table class="table table-sm">
          <tr>
            <td class="border-0">
              <h6 class="font-weight-bold text-primary">All Jobs</h6>
            </td>

            <td class="border-0">
              <h6 class="font-weight-bold text-primary">Manifest</h6>
            </td>
          </tr>

          <tr>
            <td class="border">
              <data-table
                :items="jobShippings"
                v-on:updateData="getJobShippings"
                :sortOptions="sortOptions"
                :filterOptions="filterOptions"
                :sort="sort"
                :isLoad="isLoad"
                :page="page"
                :rowsPerPage="rowsPerPage"
                :fromRow="fromRow"
                :toRow="toRow"
                :totalRows="totalRows"
                :lastPage="lastPage"
              >
                <template v-slot:rows="slotProps" v-if="!isLoad">
                  <div class="col-5 my-auto">
                    <span class="m-0 font-weight-bold bg-primary text-white px-1">{{
                      slotProps.item.job.job_number
                    }}</span
                    ><br />
                    <small class="m-0" v-if="slotProps.item.job.imei_in">{{ slotProps.item.job.imei_in }}</small>
                     <small class="m-0" v-if="slotProps.item.job.serial_in">{{ slotProps.item.job.serial_in }}</small>
                  </div>

                   <div class="col-4 my-auto">
                    <small class="m-0 font-weight-bold" v-if=" slotProps.item.job.manufacture">{{
                     slotProps.item.job.manufacture.description
                    }}</small
                    ><br />
                    <small class="m-0" v-if="slotProps.item.job.device_model.description">{{ slotProps.item.job.device_model.description }}</small>
                  </div>

                  <div class="col-2 text-right">
                    <i
                      class="lni lni-arrow-right-circle text-success pointer mt-2"
                      @click="addJob(slotProps.item)"
                    ></i>
                  </div>

                  <div class="col-1 text-right"></div>

                </template>
              </data-table>
            </td>

            <td class="border">
              <table class="table sm l-h-1">
                <tr v-for="jobShipping in shippingManifest.job_shippings" :key="jobShipping.id">
                  <td>
                    <small class="m-0 font-weight-bold">{{
                      jobShipping.job.job_number
                    }}</small
                    ><br />
                    <small class="m-0" v-if="jobShipping.job.imei_in">{{ jobShipping.job.imei_in }}</small>
                     <small class="m-0" v-if="jobShipping.job.serial_in">{{ jobShipping.job.serial_in }}</small><br />
                     <small class="m-0" v-if="jobShipping.job.manufacture">{{ jobShipping.job.manufacture.code }} : </small>
                     <small class="m-0" v-if="jobShipping.job.device_model">{{ jobShipping.job.device_model.description }}</small>
                  </td>
                  <td class="text-right">
                    <i
                      class="lni lni-arrow-left-circle text-danger pointer mt-2"
                      @click="removeJob(jobShipping)"
                    ></i>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import shippingManifestRepo from "@/api/repos/shippingManifestRepo";
import dataTable from "@/components/common/DataTable";

export default {
  props: ["id"],

  components: {
    dataTable: dataTable,
  },

  mounted() {
    this.getManifest();
  },

  data() {
    return {
      isLoad: false,
      loading: false,
      shippingManifest: {},
      jobShippings: [],
      sort: { column: "created_at", label: "Date Created Asc", order: "asc" },
      sortOptions: [
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
    };
  },

  methods: {
    async getManifest() {
      try {
        this.loading = true;
        let { data } = await shippingManifestRepo.get(this.id);
        this.shippingManifest = data.shipping_manifest;
      
        this.getJobShippings({
          id: this.id,
          sort: this.sort,
          filters: null,
          page: this.page,
          rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
          search: "",
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getJobShippings(e) {
      try {
        this.isload = true;
        let { data } = await shippingManifestRepo.jobsCreate(
          this.id,
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.jobShippings = data.job_shippings.data;
        this.totalRows = data.job_shippings.total;
        this.page = data.job_shippings.current_page;
        this.fromRow = data.job_shippings.from;
        this.toRow = data.job_shippings.to;
        this.lastPage = data.job_shippings.last_page;

        this.filterOptions = [];

       

        this.jobShippings = this.jobShippings.filter((j) => {
          let found = false;
          this.shippingManifest.job_shippings.forEach((sjs) => {
            if (sjs.id == j.id) {
              found = true;
            }
          });
          return found ? false : true;
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
    async addJob(js) {
      try {
        this.shippingManifest.job_shippings.push(js);
        this.jobShippings = this.jobShippings.filter((p) => p.id != js.id);

        try {
          await shippingManifestRepo.jobsAdd(this.id,js);
          this.$root.$bvToast.toast("Added", {
            title: "Added",
            autoHideDelay: 500,
            variant: "success",
          });
        } catch (error) {
          console.log(error)
          this.$root.$bvToast.toast("Whoops something went wrong", {
            title: "Error",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      } catch (error) {
        console.log(error);
      } 
    },


    async removeJob(js) {
      try {
        this.loading = true;
        this.shippingManifest.job_shippings = this.shippingManifest.job_shippings.filter(
          (p) => p.id != js.id
        );
        this.jobShippings.push(js);
        
        try {
          await shippingManifestRepo.jobsRemove(this.id,js);
          this.$root.$bvToast.toast("Removed", {
            title: "Removed",
            autoHideDelay: 500,
            variant: "success",
          });
        } catch (error) {
          this.$root.$bvToast.toast("Whoops something went wrong", {
            title: "Error",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
   },
};
</script>
